export class PrestacaoDeContas{
    public Tutelas: TutelaPrestacao[];
    public RPVs: RegistrosPrestacao[];
    public PercentualContratual: number;
}
export class TutelaPrestacao{
    public Id: number;
    public Descricao: string;
    public CreditoCliente: number;
    public HonorarioContratual: number;
    public Recebimentos: RecebimentosTutela[];
}
export class RegistrosPrestacao{
    public Id: number;
    public Descricao: string;
    public CreditoCliente: number;
    public HonorarioContratual: number;
    public TotalRecebido: number;
    public TotalDevedor: number;
}
export class RecebimentosTutela{
    public Valor: number;
    public Data: string;
}